import React from 'react'
import { connect, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import Logout from '../components/logout'
import Icon from './icon'
import { isMobileModeSelector, viewSelector } from 'store/selectors'
import { UserType, Views } from '../pseudo-types'
import { getBookById, getReaderBooks } from '../store/selectors'

const HeaderContainer = styled.div`
  position: fixed;
  display: flex;
  align-items: center;
  top: 0;
  z-index: 5;
  width: 100%;
  height: 60px;
  background-color: ${(p) => p.theme.colors.cream};
  padding-left: ${(p) => (p.isMobile ? '' : '1.5rem')};
  padding-right: ${(p) => (p.isMobile ? '' : '1.5rem')};
  color: ${(p) => p.theme.colors.red};
  box-shadow: 0px 5px 6px -3px rgba(0, 0, 0, 0.75);
`
export const Constrain = styled.div`
  max-width: ${(p) => p.theme.maxWidths.page};
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  @media only screen and (max-width: 768px) {
    flex: 1 1 25%;
  }
`

const Index = styled(Link)`
  color: ${(p) => p.theme.colors.red};
  font-size: ${(p) => p.theme.fontSize.title};
  line-height: ${(p) => p.theme.fontSize.title};
  text-decoration: none;
  left: ${(p) => p.theme.padding.normal};
`
const Title = styled.div`
  color: ${(p) => p.theme.colors.black};
  font-size: 1.5rem;
  font-weight: 1000;
  text-transform: uppercase;
  @media only screen and (max-width: 768px) {
    font-size: 1rem;
  }
`

export const LeftContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  color: ${(p) => p.theme.colors.red};
  & > span {
    margin-right: auto;
  }
`

export const RightContainer = styled.div`
  margin-left: ${(p) => p.theme.padding.normal};
  display: inline-flex;
  color: ${(p) => p.theme.colors.red};
  & > span {
    margin-left: auto;
  }
`

export const CenterContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  color: ${(p) => p.theme.colors.red};
  font-size: ${(p) => p.theme.fontSize.subtitle};
  text-align: center;
`

// NOTE: slot is used to inject components inside header vie React portals
const HeaderSlot = styled.div`
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`

const Home = styled(Index)`
  margin-right: 25px !important;
  @media only screen and (max-width: 768px) {
    margin-right: 5px !important;
  }
`

const getHomePage = (userType, orgnizationId) => {
  switch (userType) {
    case UserType.ADMIN:
      return '/'
    case UserType.READER:
      return '/reader'
    case UserType.CORRECTIONS:
      return '/corrections'
    case UserType.ORGANIZATION:
      return `/organizations/${orgnizationId}/`
    default:
      return null
  }
}

const Header = ({ userType, isLoggedIn, isMobile, view, children, idsByOrganizationId }) => {
  const { t } = useTranslation()

  const pathNames = window.location.pathname.split('/')

  const isbn = pathNames[3]
  const readerBooks = useSelector(getReaderBooks)
  const books = useSelector(getBookById(isbn))

  let bookTitle = books?.name || ''
  let publisherName = books?.publisherName ? books?.publisherName : books?.organizationName

  const isPronunciationGuideView = pathNames.findIndex((path) => path === 'pronunciation-guide')
  const organizationId = Object.keys(idsByOrganizationId).find((id) => id)

  if (userType === 'READER') {
    const pathiIsbn = pathNames[4]
    const readerBook = readerBooks.find(({ isbn }) => isbn === pathiIsbn)
    bookTitle = readerBook?.name || ''
    publisherName = readerBook?.publisherName ? readerBook?.publisherName : readerBook?.organizationName || ''
  }

  switch (view) {
    case Views.ADMIN_BOOK_LIST: {
      return null
    }
    default:
      break
  }

  const homePage = getHomePage(userType, organizationId)

  return (
    <HeaderContainer isMobile={isMobile}>
      <Constrain>
        <LeftContainer>
          {homePage && (
            <Home to={homePage}>
              <Icon icon="home" />
            </Home>
          )}
          <Title>Lennätin</Title>
          {userType === UserType.ADMIN && <LinkText to="/booklist">{t('bookListing')}</LinkText>}
          {isPronunciationGuideView !== -1 && (
            <HeaderTextContainer>
              <HeaderTextLeft>{bookTitle}</HeaderTextLeft>
              {publisherName && <Hyphen>{'-'}</Hyphen>}
              <HeaderTextRight>{publisherName}</HeaderTextRight>
            </HeaderTextContainer>
          )}
        </LeftContainer>
      </Constrain>
      <HeaderSlot>{children}</HeaderSlot>
      {isLoggedIn && <Logout isMobile={isMobile} />}
    </HeaderContainer>
  )
}

const HeaderTextContainer = styled.div`
  display: flex;
  align-items: center;
`

const HeaderTextLeft = styled.p`
  color: black;
  margin-left: 20px;
  margin-right: 10px;
  font-size: 20px;
  font-weight: bold;
`

const Hyphen = styled.span`
  color: black;
`

const HeaderTextRight = styled.p`
  color: black;
  font-size: 20px;
  margin-left: 10px;
  font-weight: bold;
`

const LinkText = styled(Link)`
  color: black;
  margin-left: 20px;
`

const mapStateToProps = (state) => ({
  userType: state.user.type,
  isLoggedIn: state.user.state === 'LOGGED_IN',
  isMobile: isMobileModeSelector(state),
  view: viewSelector(state),
  idsByOrganizationId: state.models.books.idsByOrganizationId,
})

export default connect(mapStateToProps)(Header)
